/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs */

const en_directory_agent_readiness_dimension_resource_discoverability = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resource discoverability`)
};

const zh_directory_agent_readiness_dimension_resource_discoverability = /** @type {(inputs: Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`资源可发现性`)
};

/**
* | output |
* | --- |
* | "Resource discoverability" |
*
* @param {Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_dimension_resource_discoverability = /** @type {((inputs?: Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Dimension_Resource_DiscoverabilityInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_dimension_resource_discoverability(inputs)
	return zh_directory_agent_readiness_dimension_resource_discoverability(inputs)
});
export { directory_agent_readiness_dimension_resource_discoverability as "directory.agent_readiness.dimension.resource_discoverability" }